import { useMutation } from 'react-query';
import AIForgeHttpService from './ai-forge-http.service';
import { IAiForgeSummaryRequestContent, IAiForgeTitleRequestContent } from '../models/ai-assistant.models';
import { showCustomToast } from '../../ArticleAiGeneration/components/subcomponents/schedules-listing-components/subcomponents/custom-toast-norification';
import i18next from 'i18next';
import { GenerateArticleRequestStatuses } from '../../ArticleAiGeneration/helpers/article-ai-generation.helper';

export const useAiForgeTitle = (onSuccessCallback: Function, onErrorCallback?: Function) => {
	return useMutation(
		async (payload: IAiForgeTitleRequestContent) => {
			const res = await AIForgeHttpService.aiForgeTitle(payload);
			return res.data;
		},
		{
			onSuccess: (data) => {
				onSuccessCallback(data);
			},
			onError: (err: Error) => {
				onErrorCallback && onErrorCallback(err);
				showCustomToast(i18next.t('error_main_title'), i18next.t('error_еxtracting_suggestions'), GenerateArticleRequestStatuses.ERROR);
			},
		},
	);
};

export const useAiForgeSummary = (onSuccessCallback: Function, onErrorCallback?: Function) => {
	return useMutation(
		async (payload: IAiForgeSummaryRequestContent) => {
			const res = await AIForgeHttpService.aiForgeSummary(payload);
			return res.data;
		},
		{
			onSuccess: (data) => {
				onSuccessCallback(data);
			},
			onError: (err: Error) => {
				onErrorCallback && onErrorCallback(err);
				showCustomToast(i18next.t('error_summary'), i18next.t('error_еxtracting_suggestions'), GenerateArticleRequestStatuses.ERROR);
			},
		},
	);
};

export const useAiForgeSeoTitle = (onSuccessCallback: Function, onErrorCallback?: Function) => {
	return useMutation(
		async (payload: IAiForgeTitleRequestContent) => {
			const res = await AIForgeHttpService.aiForgeMetaTitle(payload);
			return res.data;
		},
		{
			onSuccess: (data) => {
				onSuccessCallback(data);
			},
			onError: (err: Error) => {
				onErrorCallback && onErrorCallback(err);
				showCustomToast(i18next.t('error_seo_title'), i18next.t('error_еxtracting_suggestions'), GenerateArticleRequestStatuses.ERROR);
			},
		},
	);
};
